import React, { useState, useEffect, useCallback, useMemo } from "react";
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from "react-i18next";
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"
import { Grid, TableContainer, Table, TableRow, TableCell, TableBody, Button, FormControl, InputLabel, Select, MenuItem, IconButton, Typography, DialogActions } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import qs from 'query-string'
import { useLocation, useHistory } from "react-router-dom";
import EditIcon from '@material-ui/icons/Edit';
import TableLoader from "../../../components/common/TableLoader";
import { tablestyle, dateWithTime, trimFilters } from '../../../utils'
import EnhancedTableHead from "../../../components/common/EnhancedTableHead";
import CustomTablePagination from "../../../components/common/CustomPagination";
import * as actions from './actions';
import DeleteIcon from '@material-ui/icons/Delete';
import CustomAddModal from '../../../components/common/CustomAddModal'
import validation from '../../Validation'
import * as commonActions from '../../common/actions'
import Input from '../../../components/common/Input'
import CustomDropZone from '../../../components/common/CustomDropZone'
import CustomTooltip from "../../../components/common/CustomTooltip";
import CustomDrawer from "../../../components/common/CustomDrawer";
import CustomAccordion from "../../../components/common/CustomAccordion";
import CustomSearchBar from "../../../components/common/CustomSearchBar";
import SearchFilterButtons from "../../../components/common/SearchFilterButtons";
import CusBackdrop from '../../../components/common/Backdrop'
import CustomDialog from '../../../components/common/CommonGlobalModal/Dialog'
import { CloseIcon } from "react-material-toast/dist/Icon";

const defaultManageHead = [
  { id: 'file_name', sortByKey: 'download_link', label: "File Name", className: "show-pointer" },
  { id: 'download_link', sortByKey: 'download_link2', label: "File" },
  { id: 'version', sortByKey: 'version', label: "Version", className: "show-pointer" },
  { id: 'auto_update_message', sortByKey: 'auto_update_message', label: "Forced Update Message", isMore: true, className: "show-pointer" },
  { id: 'manual_update_message', isMore: true, sortByKey: 'manual_update_message', label: "Optional Update Message", className: "show-pointer" },
  { id: 'created_at', sortByKey: 'created_at', label: "Added On", className: "show-pointer" },
  { id: "action", sortByKey: 'action', label: "Action", stickyClassName: "more" }
];

export const ota_multiFiles = [
  { label: "Initial OTA", key: "ota_file", md_5_Key: "md_5_value" },
  { label: "MCU Upgrade 1", key: "mcu56", md_5_Key: "md_5_value_mcu56" },
  { label: "MCU Upgrade 2", key: "mcu62", md_5_Key: "md_5_value_mcu62" },
]

const initialAccordion = {
  fileNameAcc: false,
  versionAcc: false,
  md5ValueAcc: false
}

const getInitialValues = () => {
  return {
    isOpen: false,
    download_link: '',
    md_5_value: '',
    version: '',
    limit: 25,
    page: 1,
    sortBy: '',
    orderBy: 'desc',
    deviceType: 'livelink',
    ota_type: 'single',
  }
}

function Firmwares(props) {
  const { t = () => { }, toast, classes } = props;

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [refresh, setRefresh] = useState(false);
  const [deleteFirmwareId, setDeleteFirmwareId] = useState('')
  const [randomValue, setRandomValue] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [btnTitle, setBtnTitle] = useState('Add')
  const [errors, setErrors] = useState({})
  const [editMode, setEditMode] = useState(false)
  const [selectedId, setSelectedId] = useState('')
  const [urls, setURLS] = useState([]);
  const [fileToUpload, setFile] = useState([]);
  const [versions, setVersions] = useState({})
  const [messages, setMessages] = useState({})
  const [goToPage, setGoToPage] = useState('')
  const [accordion, setAccordian] = useState({ ...initialAccordion })
  const [newFilters, setNewFilters] = useState({ ...getInitialValues() })
  const [clearFilterLoader, setClearFilterLoader] = useState(false)
  const [showFullText, setShowFullText] = useState({})

  const { allFirmware = {}, isLoading = false, createLoading, totalFirmwares } = useSelector(state => state.firmware)
  const { selectedSideBarProduct = '' } = useSelector(state => state.common)

  // const delaySearch = useCallback(_.debounce(filters => refreshFirmwares(filters), 500), []);
  const delayGoToPagination = useCallback(_.debounce(filters => goToPageFun(filters), 1000), []);

  useEffect(() => {

    let tempFilter = {
      deviceType: newFilters.deviceType,
      ota_type: 'single'
    }
    if (location.search) {
      let data = { ...qs.parse(location.search, { arrayFormat: 'bracket', }) }
      let {
        fileNameAcc = false,
        versionAcc = false,
        md5ValueAcc = false,
        isOpen = false,
        download_link = '',
        md_5_value = '',
        version = '',
        limit = 25,
        page = 1,
        sortBy = '',
        orderBy = 'desc',
        deviceType = 'livelink',
        ota_type = 'single'
      } = data

      tempFilter = {
        isOpen: isOpen === "false" ? false : true,
        download_link,
        md_5_value,
        version,
        limit: parseInt(limit),
        page: parseInt(page),
        sortBy,
        orderBy,
        deviceType,
        ota_type
      }
      if (selectedSideBarProduct === 'heat_pump') {
        tempFilter.ota_type = ota_type
      }

      let tempAcc = {
        fileNameAcc: fileNameAcc === "false" ? false : true,
        versionAcc: versionAcc === "false" ? false : true,
        md5ValueAcc: md5ValueAcc === "false" ? false : true,
      }
      setNewFilters(tempFilter)
      setAccordian(tempAcc)
    }
    refreshFirmwares(tempFilter)
    return () => {
      dispatch(actions.clearStoreForFirmware())
    }
  }, [])

  useEffect(() => {
    if (openModal === false)
      setTimeout(() => {
        setBtnTitle('Add')
      }, 150)
  }, [openModal])

  useEffect(() => {
    let tempFilter = { ...accordion, ...trimFilters(newFilters) }
    location.search = qs.stringify({ ...tempFilter })
    history.push({
      pathname: '/admin/firmwares',
      search: location.search
    })
  }, [accordion, newFilters])

  useEffect(() => {
    if (deleteFirmwareId) {
      dispatch(commonActions.openDeleteModal({
        confirmAction: deleteFirmware,
        title: 'DELETE FIRMWARE',
        dialogtext: 'Are you sure you want to delete this Firmware?'
      }))
    }
  }, [randomValue])

  const refreshFirmwares = (filters) => {
    if (selectedSideBarProduct !== 'livelink') {
      filters = { ...filters, deviceType: selectedSideBarProduct === 'electricity-advisor' ? 'ihd' : selectedSideBarProduct }
    }
    dispatch(actions.getAllFirmware(filters))
  }

  const goToPageFun = (value) => {
    refreshFirmwares(value)
  }

  const handleFilterChange = (e) => {
    const { value } = e.target
    setNewFilters(prev => ({ ota_type: value }))
    refreshFirmwares({ ota_type: value })
    // setNewFilters(prev => ({ ...prev, ota_type: value }))
    // refreshFirmwares({ ...newFilters, ota_type: value })
  }

  const onClickRefresh = () => {
    setRefresh(true)
    let tempFilter = {
      ...newFilters,
      deviceType: selectedSideBarProduct !== 'livelink' ? selectedSideBarProduct === 'electricity-advisor' ? 'ihd' : selectedSideBarProduct : newFilters.deviceType
    }
    dispatch(actions.getAllFirmware(tempFilter)).then(() => setRefresh(false)).catch(err => setRefresh(false))
  }

  const onPageChange = (e, page) => {
    refreshFirmwares({ ...newFilters, page })
    setNewFilters({ ...newFilters, page })
  }

  const uploadFiles = (files = [], key, i = 0) => {
    let image = {};
    let updateData = {};
    let newFiles = []

    if (fileToUpload.length) newFiles = [...fileToUpload]

    newFiles = [...files]
    if (newFiles.length > 1) return;
    const newFile = newFiles[0]

    setErrors({ ...errors, fileToUpload: '' })

    if (newFile.type.split("/")[0] === "image") {
      image = { key, name: newFile?.name, url: URL.createObjectURL(newFile) }
      updateData = { key, file: newFile }
    } else if (newFile.type === "application/pdf") {
      image = { key, name: newFile?.name, url: "/images/pdf-icon.svg" }
      updateData = { key, file: newFile }
    } else if (newFile.type === "application/octet-stream") {
      image = { key, name: newFile?.name, url: "/images/binary.png" }
      updateData = { key, file: newFile }
    } else {
      image = { key, name: newFile?.name, url: "/images/binary.png" }
      updateData = { key, file: newFile }
    }

    setFile(prev => {
      const updatedData = [...prev]
      updatedData[i] = { ...updatedData[i], ...updateData }
      return updatedData;
    })
    setURLS(prev => {
      const updatedData = [...prev]
      updatedData[i] = { ...updatedData[i], ...image }
      return updatedData;
    })

  };

  const removeImage = (i, item) => {
    let deletedDataFilter = [...fileToUpload]
    const dataIndex = deletedDataFilter.findIndex(file => file.key === item.key)
    deletedDataFilter[dataIndex] = { ...deletedDataFilter[dataIndex], key: "", file: null, name: "", url: "", }
    setFile(deletedDataFilter)

    let deletedBlob = [...urls]
    const index = deletedBlob.findIndex(file => file.key === item.key)
    deletedBlob[index] = { ...deletedBlob[index], key: "", file: null, name: "", url: "" }
    setURLS(deletedBlob)
  }

  const isValid = () => {
    const { isValid, errors } = validation.addFirmware({ fileToUpload, ota_type: newFilters.ota_type, ...versions })
    if (!isValid) {
      setErrors(errors)
    };
    return isValid;
  }

  const enableEditMode = (item) => {
    const {
      id, download_link, md_5_value, version, mcu_version, file_name,
      ota_files = [],
      auto_update_message = "",
      manual_update_message = "",
    } = item || {}
    let images = [{ key: "ota_file", name: file_name, url: "/images/binary.png", md_5_Key: "md_5_value", md_5_value, file: download_link }]


    if (ota_files && ota_files.length && Array.isArray(ota_files)) {
      const ota_images = ota_files?.map(file => {
        const md_5_Key = ota_multiFiles.find(ota_file => ota_file.key === file.key)?.md_5_Key
        return ({ key: file.key, name: file.file_name, url: "/images/binary.png", md_5_Key, [md_5_Key]: file.md_5_value, file: file.download_link })
      })
      images = [...images, ...ota_images]
    }

    setMessages({ auto_update_message, manual_update_message })
    setSelectedId(id)
    setVersions({ firmwareVersion: version, mcu_version, md_5_value })
    setFile(images)
    setURLS(images)
    setOpenModal(true)
    setEditMode(true)
    setBtnTitle('Update')
  }

  const handleModalClose = () => {
    setEditMode(false)
    setSelectedId('')
    setFile([])
    setVersions({})
    setMessages({})
    setURLS([])
    setOpenModal(false)
    setErrors({})
    // setBtnTitle('Add')
  }

  const onDeleteFirmware = (id) => {
    setRandomValue(Math.random())
    setDeleteFirmwareId(id)
  }

  const deleteFirmware = () => {
    dispatch(actions.deleteFirmware(deleteFirmwareId, selectedSideBarProduct !== 'livelink' ? selectedSideBarProduct === 'electricity-advisor' ? 'ihd' : selectedSideBarProduct : newFilters.deviceType)).then(res => {
      setNewFilters({ ...newFilters, limit: newFilters?.limit, page: 1, sortBy: 'created_at', orderBy: 'desc', })
      refreshFirmwares({ ...newFilters, limit: newFilters?.limit, page: 1, sortBy: 'created_at', orderBy: 'desc', })
      setDeleteFirmwareId('')
      setRandomValue('')
    })
  }

  const onChangeVersion = ({ target: { name = '', value = '' } }) => {
    // if (!value.match(/^[\.0-9]*$/)) return
    setVersions(prev => ({ ...prev, [name]: value }))
    setErrors({ ...errors, [name]: '' })
  };

  const onChangeLimit = (e) => {
    refreshFirmwares({ ...newFilters, limit: e.target.value, page: 1, sortBy: 'created_at', orderBy: 'desc', })
    setNewFilters({ ...newFilters, limit: e.target.value, page: 1, })
    setGoToPage('')
  }

  const onSortBy = (label) => {
    if (label === "action" || label === "download_link2") return
    let orderBy = ''
    if (newFilters.orderBy === 'desc') {
      orderBy = 'asc'
    } else {
      orderBy = 'desc'
    }
    const filters = { ...newFilters, sortBy: label, orderBy: orderBy }
    setNewFilters(filters)
    refreshFirmwares(filters)
  }

  const onSubmitModal = () => {
    if (isValid()) {
      if (editMode) {
        dispatch(actions.updateFirmware({
          ...messages, ota_type: newFilters.ota_type, selectedId, fileToUpload, ...versions,
          deviceType: selectedSideBarProduct !== 'livelink' ? selectedSideBarProduct === 'electricity-advisor' ? 'ihd' : selectedSideBarProduct : newFilters.deviceType
        })).then(res => {
          refreshFirmwares(newFilters)
          handleModalClose()
        })
      } else {
        dispatch(actions.createFirmware({
          ...messages, ota_type: newFilters.ota_type, ...versions, fileToUpload,
          deviceType: selectedSideBarProduct !== 'livelink' ? selectedSideBarProduct === 'electricity-advisor' ? 'ihd' : selectedSideBarProduct : newFilters.deviceType
        })).then(res => {
          refreshFirmwares(newFilters)
          handleModalClose()
        })
      }
    }
  }

  const onChangeGoToPage = ({ target: { value = '' } }) => {
    if (!value.match(/^[0-9]*$/) || value === "0") return
    let pageValue = Math.ceil(totalFirmwares / newFilters.limit)
    if (value > pageValue) return
    setGoToPage(value ? parseInt(value) : '')
    setNewFilters({ ...newFilters, page: value ? parseInt(value) : '' })
    delayGoToPagination({ ...newFilters, page: value })
  }

  const openFilterSidebar = () => {
    setNewFilters({ ...newFilters, isOpen: true })
  }

  const onCloseFiltersDrawer = () => {
    setNewFilters({ ...newFilters, isOpen: false })
  }

  const handleChangeAccordion = (panel, filterKey) => (event, isExpanded) => {
    if (!isExpanded) {
      setNewFilters({ ...newFilters, [filterKey]: '', page: newFilters[filterKey]?.length ? 1 : newFilters.page })
    }
    setAccordian({ ...accordion, [panel]: isExpanded })

  };

  const onChangeFilter = ({ target: { name = '', value = '' } }) => {
    let tempFilter = { ...newFilters }
    tempFilter = { ...tempFilter, [name]: value, page: 1 }
    setNewFilters(tempFilter)
    // delaySearch({ ...tempFilter })
  }

  const applyFilter = () => {
    refreshFirmwares({ ...trimFilters(newFilters), page: 1 })
  }

  const clearFilter = () => {
    setClearFilterLoader(true)
    let tempFilter = {
      isOpen: newFilters.isOpen,
      download_link: '',
      md_5_value: '',
      version: '',
      limit: 25,
      page: 1,
      sortBy: '',
      orderBy: 'desc',
      deviceType: selectedSideBarProduct !== 'livelink' ? selectedSideBarProduct === 'electricity-advisor' ? 'ihd' : selectedSideBarProduct : newFilters.deviceType
    }

    setNewFilters({ ...tempFilter })
    setAccordian({ ...initialAccordion })
    dispatch(actions.getAllFirmware(tempFilter)).then(res => {
      setClearFilterLoader(false)
    })
  }

  const onChangeKeyDown = (e) => {
    if (e.key === 'Enter') {
      refreshFirmwares({ ...trimFilters(newFilters), page: 1 })
    }
  }

  const onSelectDeviceType = (e) => {
    refreshFirmwares({ ...newFilters, deviceType: e.target.value, page: 1, sortBy: 'created_at', orderBy: 'desc' })
    setNewFilters({ ...newFilters, deviceType: e.target.value, page: 1, sortBy: 'created_at', orderBy: 'desc' })
    setGoToPage('')
  }

  const manageHead = useMemo(() => {
    if (newFilters.ota_type === 'single') {
      let tempHead = [...defaultManageHead]
      tempHead?.splice(3, 0, { id: 'md_5_value', sortByKey: 'md_5_value', label: "MD5 Value", className: "show-pointer" })
      return tempHead;
    }
    return defaultManageHead;

  }, [newFilters.ota_type])

  return (
    <Grid container className="location-container heatdb-p0" >
      <Grid item xs={12} >
        <Grid container className="location-head" alignItems='center' >
          <Grid item xs={12} sm={12} lg={4} md={4} xl={8} className="heading">
            <h2>Firmwares</h2>
          </Grid>
          <Grid item xs={12} sm={12} lg={8} md={8} xl={4}>
            <div style={{ display: 'flex', gap: "10px", justifyContent: 'flex-end', alignItems: 'center' }}>
              <div style={{ background: '#ffffff', display: 'flex', gap: "10px", justifyContent: 'flex-end', alignItems: 'center' }}>
                {
                  selectedSideBarProduct === 'livelink' ?
                    <div>
                      <ul className="custom-list-style">
                        <li className="target-version">
                          <FormControl variant="outlined" className="w-full">
                            <InputLabel id="demo-simple-select-outlined-label">Select Device Type</InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              value={newFilters.deviceType}
                              onChange={onSelectDeviceType}
                              className="ota-select"
                            >
                              <MenuItem value={"ihd_livelink"}>IHD</MenuItem>
                              <MenuItem value={"livelink"}>Livelink</MenuItem>
                            </Select>
                          </FormControl>
                        </li>
                      </ul>
                    </div>
                    : selectedSideBarProduct === 'heat_pump' ? <div>
                      <ul className="custom-list-style m-0">
                        <li className="target-version">
                          <FormControl variant="outlined" className="w-full">
                            <InputLabel id="demo-simple-select-outlined-label">Select Firmware Type</InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              value={newFilters.ota_type}
                              onChange={handleFilterChange}
                              className="ota-select"
                            >
                              <MenuItem value={"single"}>Single</MenuItem>
                              <MenuItem value={"multiple"}>OTA Pack</MenuItem>
                            </Select>
                          </FormControl>
                        </li>
                      </ul>
                    </div> : null
                }

                <div className="search-add">
                  <Button className="button-btn btn-custom-primary mr-3" onClick={() => setOpenModal(true)}><AddIcon />Add Firmware</Button>
                  <IconButton aria-label="filter" onClick={openFilterSidebar}>
                    <FilterListIcon />
                    <Typography variant="body1" style={{ marginLeft: 8 }}>
                      Search
                    </Typography>
                  </IconButton>
                  <CustomDrawer isOpen={newFilters.isOpen} onClose={onCloseFiltersDrawer} >
                    <ul className="list-style-list">
                      <CusBackdrop open={isLoading} className="loader-images" />
                      <li>
                        <CustomAccordion
                          isOpen={accordion.fileNameAcc}
                          handleChange={handleChangeAccordion('fileNameAcc', 'download_link')}
                          label={"File Name"}
                        >
                          <CustomSearchBar
                            placeholder="Enter File Name"
                            value={newFilters.download_link}
                            onChange={onChangeFilter}
                            name={'download_link'}
                            onChangeKeyDown={onChangeKeyDown}

                          />
                        </CustomAccordion>
                      </li>
                      {newFilters.ota_type === 'single' && <li>
                        <CustomAccordion
                          isOpen={accordion.md5ValueAcc}
                          handleChange={handleChangeAccordion('md5ValueAcc', 'md_5_value')}
                          label={"MD5 Value"}
                        >
                          <CustomSearchBar
                            placeholder="Enter MD5 Value"
                            value={newFilters.md_5_value}
                            onChange={onChangeFilter}
                            name={'md_5_value'}
                            onChangeKeyDown={onChangeKeyDown}

                          />
                        </CustomAccordion>
                      </li>}
                      <li>
                        <CustomAccordion
                          isOpen={accordion.versionAcc}
                          handleChange={handleChangeAccordion('versionAcc', 'version')}
                          label={"Version"}
                        >
                          <CustomSearchBar
                            placeholder="Enter Version"
                            value={newFilters.version}
                            onChange={onChangeFilter}
                            name={'version'}
                            onChangeKeyDown={onChangeKeyDown}

                          />
                        </CustomAccordion>
                      </li>
                      <li>
                        <SearchFilterButtons
                          clearFilter={clearFilter}
                          applyFilter={applyFilter}
                          isLoading={isLoading}
                          clearFilterLoader={clearFilterLoader}
                        />
                      </li>
                    </ul>
                  </CustomDrawer>
                </div>
              </div>

              <div>

              </div>
            </div>
            {/* <Grid container alignItems="center">
                            {
                                selectedSideBarProduct === 'livelink' && <Grid item xs={12} sm={12} lg={6} md={6} xl={selectedSideBarProduct === 'livelink' ? 4 : 12}>

                                </Grid>
                            }
                            <Grid item xs={12} sm={12} lg={selectedSideBarProduct === 'livelink' ? 6 : 12} md={selectedSideBarProduct === 'livelink' ? 6 : 12} xl={selectedSideBarProduct === 'livelink' ? 8 : 12}>
                                <div className="search-add">
                                    <Button className="button-btn btn-custom-primary mr-3" onClick={() => setOpenModal(true)}><AddIcon />Add Firmware</Button>
                                    <button className="filter-btn-style" onClick={openFilterSidebar}><img src="/images/filter.svg" /></button>
                                    <CustomDrawer isOpen={newFilters.isOpen} onClose={onCloseFiltersDrawer} >
                                        <ul className="list-style-list">
                                            <CusBackdrop open={isLoading} className="loader-images" />
                                            <li>
                                                <CustomAccordion
                                                    isOpen={accordion.fileNameAcc}
                                                    handleChange={handleChangeAccordion('fileNameAcc', 'download_link')}
                                                    label={"File Name"}
                                                >
                                                    <CustomSearchBar
                                                        placeholder="Enter File Name"
                                                        value={newFilters.download_link}
                                                        onChange={onChangeFilter}
                                                        name={'download_link'}
                                                        onChangeKeyDown={onChangeKeyDown}

                                                    />
                                                </CustomAccordion>
                                            </li>
                                            <li>
                                                <CustomAccordion
                                                    isOpen={accordion.versionAcc}
                                                    handleChange={handleChangeAccordion('versionAcc', 'version')}
                                                    label={"Version"}
                                                >
                                                    <CustomSearchBar
                                                        placeholder="Enter Version"
                                                        value={newFilters.version}
                                                        onChange={onChangeFilter}
                                                        name={'version'}
                                                        onChangeKeyDown={onChangeKeyDown}

                                                    />
                                                </CustomAccordion>
                                            </li>
                                            <li>
                                                <SearchFilterButtons
                                                    clearFilter={clearFilter}
                                                    applyFilter={applyFilter}
                                                    isLoading={isLoading}
                                                    clearFilterLoader={clearFilterLoader}
                                                />
                                            </li>
                                        </ul>
                                    </CustomDrawer>
                                </div>
                            </Grid>
                        </Grid> */}
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} className="content-container">
        <div id="no-more-tables" className="card-design table-design cf" >

          {
            isLoading ?
              <>
                <TableContainer className={classes.container} style={{ overflow: "hidden" }}>
                  <Table className="table-program" stickyHeader aria-label="sticky table">
                    <EnhancedTableHead headCells={manageHead} />
                  </Table>
                </TableContainer>
                <TableLoader />
              </>
              : null
          }

          {
            !isLoading ? <TableContainer className={classes.container}>
              <Table className="table-program" stickyHeader aria-label="sticky table">
                <EnhancedTableHead
                  onSortBy={onSortBy}
                  headCells={manageHead}
                  filters={newFilters}
                />
                <TableBody>
                  {
                    allFirmware && allFirmware.length ? allFirmware.map((item, index) => {
                      return <TableRow key={item.id} hover role="checkbox" className="cursor_default">
                        <TableCell className="table-custom-width">{item.file_name || "-"}</TableCell>
                        <TableCell>
                          <CustomTooltip title="Download Firmware File" placement="right">
                            <img src="/images/binary.png" alt="drop-image" onClick={() => window.open(item.download_link, "_self")} style={{ width: 45, height: 45, cursor: "pointer" }} />
                          </CustomTooltip>
                        </TableCell>
                        <TableCell className="table-custom-width">{item.version}</TableCell>
                        {newFilters.ota_type === 'single' && <TableCell className="table-custom-width">{item.md_5_value || "-"}</TableCell>}
                        <TableCell className="table-custom-width">
                          {
                            item.auto_update_message?.length > 40 ?
                              <>
                                <p>{item.auto_update_message?.slice(0, 40)}</p>
                                <button className="read-more" onClick={() => setShowFullText({
                                  message: item.auto_update_message,
                                  type: "Forced Update Message",
                                  version: item.version
                                })}>Read More</button>
                              </>
                              : item.auto_update_message || "-"
                          }
                        </TableCell>
                        <TableCell className="table-custom-width">
                          {
                            item.manual_update_message?.length > 40 ?
                              <>
                                <p>{item.manual_update_message?.slice(0, 40)}</p>
                                <button className="read-more" onClick={() => setShowFullText({
                                  message: item.manual_update_message,
                                  type: "Optional Update Message",
                                  version: item.version
                                })}>Read More</button>
                              </>
                              : item.manual_update_message || "-"
                          }</TableCell>
                        <TableCell className="table-custom-width">{dateWithTime(item?.created_at) || "-"}</TableCell>
                        <TableCell className="table-custom-width more">
                          <EditIcon className="show-pointer" onClick={() => enableEditMode(item)} />
                          <DeleteIcon className="show-pointer" onClick={() => onDeleteFirmware(item.id)} />
                        </TableCell>
                      </TableRow>
                    })
                      :
                      <TableRow>
                        <TableCell style={{ border: "none" }} colSpan="5" className="table-no-data">No Data Found</TableCell>
                      </TableRow>
                  }
                </TableBody>
              </Table>
            </TableContainer> : null
          }

          <CustomTablePagination
            count={totalFirmwares}
            refresh={refresh}
            onClickRefresh={onClickRefresh}
            filters={newFilters}
            onPageChange={onPageChange}
            onChangeLimit={onChangeLimit}
            onChangeGoToPage={onChangeGoToPage}
            goToPage={goToPage}
          />
        </div>
      </Grid>

      <CustomAddModal
        open={openModal}
        createBtnTitle={btnTitle}
        handleClose={handleModalClose}
        createHandler={onSubmitModal}
        closeHandler={handleModalClose}
        title={newFilters.ota_type === "single" ? "Firmware" : "Firmware OTA Pack"}
        createLoading={createLoading}
      >
        <Grid container className="px-5">
          <Grid item md={12} className={`d-flex align-center firware-ver firmware-version-field input-group mb-4`} >
            {/* <lable>Firware version</lable> */}
            <FormControl fullWidth>
              <Input
                variant="outlined"
                fullWidth
                name="firmwareVersion"
                label="Firmware Version *"
                type="text"
                value={versions.firmwareVersion || ""}
                onChange={onChangeVersion}
                id='firmware'
                error={errors?.firmwareVersion}
              />
            </FormControl>
          </Grid>
          {newFilters.ota_type === 'single' && <Grid item md={12} className={`d-flex align-center firware-ver firmware-version-field input-group mb-4`} >
            <FormControl fullWidth>
              <Input
                variant="outlined"
                fullWidth
                name="md_5_value"
                label="MD5 Value"
                type="text"
                value={versions.md_5_value || ""}
                onChange={onChangeVersion}
                id='md_5_value'
                error={errors?.md_5_value}
              />
            </FormControl>
          </Grid>}
          <Grid item md={12} className="d-flex align-center mb-4 input-group" >
            <FormControl fullWidth>
              <Input
                variant="outlined"
                fullWidth
                name="auto_update_message"
                label="Forced Update Message"
                type="text"
                value={messages.auto_update_message || ""}
                onChange={e => setMessages({ ...messages, auto_update_message: e.target.value })}
                id='firmware'
              />
            </FormControl>
          </Grid>
          <Grid item md={12} className="d-flex align-center mb-1 input-group" >
            {/* <lable>Firware version</lable> */}
            <FormControl fullWidth>
              <Input
                variant="outlined"
                fullWidth
                name="manual_update_message"
                label="Optional Update Message"
                type="text"
                value={messages.manual_update_message || ""}
                onChange={e => setMessages({ ...messages, manual_update_message: e.target.value })}
                id='firmware'
              />
            </FormControl>
          </Grid>
          {
            newFilters.ota_type === 'multiple' ?
              <>
                {
                  ota_multiFiles?.slice(0, 1).map((fileOption, i) => (
                    <>
                      <lable className="title-firmware" style={{ marginBottom: "2px", marginTop: "14px" }}>{fileOption.label}</lable>
                      <Grid item md={12} className="firware-ver add-btn1 custom-border" >
                        <FormControl fullWidth>
                          <Input
                            variant="outlined"
                            fullWidth
                            name={fileOption.md_5_Key}
                            label="md5 *"
                            type="text"
                            value={fileToUpload?.[i]?.[fileOption.md_5_Key] || ""}
                            onChange={e => {
                              const updatedFiles = [...fileToUpload]
                              updatedFiles[i] = { ...(updatedFiles?.[i] || {}), [fileOption.md_5_Key]: e.target.value, md_5_Key: fileOption.md_5_Key }
                              setFile(updatedFiles)
                            }}
                            id={fileOption.md_5_Key}
                            error={errors?.fileToUpload?.[fileOption.md_5_Key]}
                          />
                        </FormControl>
                        <Grid item md={12} className="d-flex align-center firware-ver add-btn1" >
                          <CustomDropZone
                            setFile={(v) => { uploadFiles(v, fileOption.key, i) }}
                            src={urls?.filter(file => file.key === fileOption.key)}
                            id="firmware"
                            isMultiple={false}
                            files={[fileToUpload]}
                            removeImage={removeImage}
                            accept={".bin"}
                            error={errors?.fileToUpload?.[fileOption.key]}
                            noDrag={false}
                          />
                        </Grid>
                      </Grid>
                    </>
                  ))
                }
                <Grid item md={12} className="d-flex align-center firware-ver input-group" >
                  {/* <lable>Firware version</lable> */}
                  <FormControl fullWidth>
                    <Input
                      variant="outlined"
                      fullWidth
                      name="mcu_version"
                      label="MCU Version *"
                      type="text"
                      value={versions.mcu_version || ""}
                      onChange={onChangeVersion}
                      id='mcu_version'
                      error={errors?.mcu_version}
                    />
                  </FormControl>
                </Grid>
                {
                  ota_multiFiles?.slice(1).map((fileOption, ind) => {
                    const i = ind + 1;
                    return (
                      <>
                        <lable className="title-firmware" style={{ marginBottom: "2px", marginTop: "14px" }}>{fileOption.label}</lable>
                        <Grid item md={12} className="firware-ver add-btn1 custom-border" >
                          <FormControl fullWidth>
                            <Input
                              variant="outlined"
                              fullWidth
                              name={fileOption.md_5_Key}
                              label="md5 *"
                              type="text"
                              value={fileToUpload?.[i]?.[fileOption.md_5_Key] || ""}
                              onChange={e => {
                                const updatedFiles = [...fileToUpload]
                                updatedFiles[i] = { ...(updatedFiles?.[i] || {}), [fileOption.md_5_Key]: e.target.value, md_5_Key: fileOption.md_5_Key }
                                setFile(updatedFiles)
                              }}
                              id={fileOption.md_5_Key}
                              error={errors?.fileToUpload?.[fileOption.md_5_Key]}
                            />
                          </FormControl>
                          <Grid item md={12} className="d-flex align-center firware-ver add-btn1" >
                            <CustomDropZone
                              setFile={(v) => { uploadFiles(v, fileOption.key, i) }}
                              src={urls?.filter(file => file.key === fileOption.key)}
                              id="firmware"
                              isMultiple={false}
                              files={[fileToUpload]}
                              removeImage={removeImage}
                              accept={".bin"}
                              error={errors?.fileToUpload?.[fileOption.key]}
                              noDrag={false}
                            />
                          </Grid>
                        </Grid>
                      </>
                    )
                  })
                }
              </>
              : <Grid item md={12} className="d-flex align-center firware-ver add-btn1" >
                <CustomDropZone
                  setFile={(v) => { uploadFiles(v, "ota_file") }}
                  src={urls}
                  id="firmware"
                  isMultiple={false}
                  files={[fileToUpload]}
                  removeImage={removeImage}
                  accept={".bin"}
                  error={errors?.fileToUpload}
                  noDrag={false}
                />
              </Grid>
          }
        </Grid>
      </CustomAddModal>

      {/* Full message modal */}
      {
        showFullText?.message &&
        <CustomDialog customFunction={() => setShowFullText({})}>
          <Grid container className="p-24 break-all modal-read-contents">
            <div className="w-100 border-bottom">
              <h4>{showFullText?.type} ({showFullText.version})</h4>
              <IconButton onClick={() => setShowFullText({})} className="close">
                <CloseIcon />
              </IconButton>
            </div>
            <div className="modal-conts">
              <p className="text-left">{showFullText?.message}</p>
            </div>
            {/* <DialogActions className="dialog-btns modal-add-pdf mt-4">
                            <Button onClick={() => setShowFullText({})} className="button-btn btn-custom-black"  >
                                Close
                            </Button>
                        </DialogActions> */}
          </Grid>
        </CustomDialog>
      }
    </Grid >
  );
}



export default withTranslation("translations")(withStyles(tablestyle)(Firmwares));

